import { createApiCall } from '../../services/apiClient';

export type ActionType = 'journeyItemCompleted' | 'ollieChatEngagement' | 'triggerLogged';
export interface StreakTarget { userId: string; timezone: string }
export interface StreakFreezes { available: number; progressDays: number }
export interface StreakSummary { current: number; longest: number; lastDay: string | null; lastTz: string | null; runStartDay?: string | null; protectedThrough?: string | null }
export interface StreakState extends StreakTarget {
    dayKey: string;
    revision: string | null;
    canWrite: boolean;
    streak: StreakSummary;
    displayedStreak: number;
    streakFreezes: StreakFreezes;
    activeDaysTotal: number;
    actionCounts: Record<ActionType, number>;
    days: { day: string; categories: string[]; streakDay: number | null }[];
    frozenDays: string[];
  freezeNotification: { id: string; count: number; streak: number } | null;
  hasMoreDays: boolean;
}
export interface SeedOptions {
    state: 'empty' | 'active' | 'at-risk' | 'broken';
    streakLength: number;
    missedDays?: number;
  appliedFreezes?: number;
  pendingNotification?: boolean;
  includeHistory: boolean;
    streakFreezes: StreakFreezes;
}
export interface SeedPreview {
    dayKey: string;
    revision: string | null;
    days: string[];
    eventCount: number;
    replacedDays: number;
    replacedEvents: number;
    streak: StreakSummary;
    displayedStreak: number;
    streakFreezes: StreakFreezes;
    frozenDays: string[];
  replacedFrozenDays: number;
  applied: boolean;
}
export interface StreakPatch {
    streak?: Omit<StreakSummary, 'lastTz'>;
    streakFreezes?: StreakFreezes;
}
export const streakService = {
    get: createApiCall<StreakTarget, StreakState>('adminGetStreakState'),
    update: createApiCall<StreakTarget & StreakPatch & { expectedRevision: string | null }, { saved: true }>('adminUpdateStreakState'),
    seed: createApiCall<StreakTarget & SeedOptions & {
        apply?: boolean; replace?: boolean; expectedRevision?: string | null; expectedDayKey?: string;
    }, SeedPreview>('adminSeedStreakActivity'),
    recordAction: createApiCall<StreakTarget & { type: ActionType; countsOccurrence: boolean }, { isNewDay: boolean }>('adminRecordStreakAction'),
};
